import { FC } from 'react'
import { UserPersonalDetails } from 'components/User'
import { UserProtectedRoute } from 'routes'

const UserPersonalDataPage: FC = () => {
  return (
    <UserProtectedRoute>
      <UserPersonalDetails />
    </UserProtectedRoute>
  )
}

export default UserPersonalDataPage
